<template>
  <div class="media-gallery-dots">
    <button
      v-for="item in galleryItems"
      :key="item.src"
      type="button"
      :data-dot="item.index"
      class="media-gallery-dots__dot"
      :class="{
        'media-gallery-dots__dot--active': activeItem?.src === item.src,
      }"
      @click="onClick(item.index)"
    />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  name: string
}>()

const { galleryOptions, galleryItems, activeItem, setItem } = useUiMediaGallery(props.name)

const onClick = (index: number) => {
  setItem(index, galleryOptions.value.behavior)
}
</script>

<style>
@import url("~layers/app/components/Ui/MediaGallery/Dots.css");
</style>
